<template>
    <div class="templateDetailsPage">
        <head-top :slide="false"></head-top>
        <div class="templateHeadBox">
          <div class="imgPreviewBox">
            <div class="swiper-button-prev"></div>
            <div class="preview">
              <!-- 轮播图 -->
              <swiper class="mod-banner-scroll" :options="swiperOption">
                <swiper-slide v-for="(item,index) of detailsInfo.imgs" :key="index">
                  <img :src="item">
                  <span></span>
                </swiper-slide>
              </swiper>
            </div>
            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-next"></div>
          </div>
          <div class="templateInfo">
              <h3>{{detailsInfo.title}}</h3>
              <div class="description">{{detailsInfo.title}}</div>
              <div class="score">
                <i class="icon" :class="{'current':detailsInfo.score >= 1}">&#xe673;</i>
                <i class="icon" :class="{'current':detailsInfo.score >= 2}">&#xe673;</i>
                <i class="icon" :class="{'current':detailsInfo.score >= 3}">&#xe673;</i>
                <i class="icon" :class="{'current':detailsInfo.score >= 4}">&#xe673;</i>
                <i class="icon" :class="{'current':detailsInfo.score >= 5}">&#xe673;</i>
                （4分）
              </div>
              <div class="buyNum">
                  <span>{{detailsInfo.buyNum}}</span> 个人购买
              </div>
              <div class="price">
                  <span>￥{{detailsInfo.price}}</span>
                  <span>原价：￥{{detailsInfo.originalPrice}}</span>
              </div>
              
              <div class="types">
                  适用类型：
                  <span v-if="detailsInfo.type == 1101">APP</span>
                  <span v-if="detailsInfo.type == 1201">公众号</span>
                  <span v-if="detailsInfo.type == 1301">小程序</span>
              </div>
              <div class="but">
                <div v-for="(item,index) of detailsInfo.preview" :key="index">
                  <p>微信体验一下预览</p>
                  <img :src="item">
                </div>
              </div>
          </div>
          <div class="recommend">
            <div class="title">其他推荐</div>
            <div class="recommendList" v-for="(item,index) of recommendList" :key="index" @click="dataLoad(item.index)">
              <div class="recommendImg">
                <img :src="item.coverImg">
              </div>
              <div class="content">
                <h2>{{item.title}}</h2>
                <div>
                  <span>￥{{item.price}}</span>
                  <span>￥{{item.originalPrice}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="details" v-if="(detailsInfo.description instanceof Array)">
            <img v-for="(item,index) of detailsInfo.description" :key="index" :src="item">
        </div>
        <div class="detailsText" v-else v-html="detailsInfo.description"></div>
        <foot-guide></foot-guide>
    </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      detailsInfo: {},
      swiperOption: {
        autoplay: 3200,
        setWrapperSize: true,
        observeParents: true,
        // loop: true,
        speed: 400,
        //设置分页
        pagination: ".swiper-pagination",
        //设置分页点击
        paginationClickable: true,
        //设置上一页，下一页
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        autoplayDisableOnInteraction: false
      },
      recommendList: []
    };
  },
  methods: {
    dataLoad(index) {
      if (index !== undefined) {
        this.detailsInfo = templateDtata[index];
      }
      const _this = this;
      var len = templateDtata.length;
      var times = 3;
      var recommendList = new Array();
      var numList = [index];
      getRandom(1);
      function getRandom(index) {
        var result = Math.floor(Math.random() * len);
        var state = true;
        numList.forEach(item => {
          if (item == result) {
            state = false;
          }
        });
        if (state) {
          numList.push(result);
          var item = templateDtata[result];
          item.index = result;
          recommendList.push(item);
          if (times > index) {
            getRandom(index + 1);
          } else {
            _this.recommendList = recommendList;
          }
        } else {
          getRandom(index);
        }
      }
    }
  },
  mounted() {
    var index = this.$route.params.index;
    this.dataLoad(index);
  }
};
</script>
<style lang="scss" scoped>
@import "src/style/mixin";
@media screen and (min-width: 1000px) {
  .templateDetailsPage {
    padding-top: 76px;
    .templateHeadBox {
      margin: 20px auto;
      max-width: 1200px;
      background-color: #fff;
      padding: 0 30px;
      display: flex;
      .imgPreviewBox {
        position: relative;
        display: flex;
        align-items: center;
        margin-right: 30px;
        flex-shrink: 0;
        padding: 30px 0;
        .preview {
          width: 260px;
          height: 482px;
          background: url(https://qn.kemean.cn/upload/201809/06/fe154e4732694900a7254981d1e3a893)
            no-repeat;
          background-size: 100%;
          position: relative;
          padding: 40px 30px 80px 30px;
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide {
              width: 100%;
              height: 100%;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .swiper-button-prev {
          position: initial;
        }
        .swiper-button-next {
          position: initial;
        }
      }
      .templateInfo {
        flex: 1;
        padding: 30px 0;
        h3 {
          color: #000;
          font-size: 22px;
          font-weight: bold;
        }
        .description {
          margin-top: 15px;
          color: #999;
          font-size: 16px;
        }
        .score {
          margin-top: 15px;
          color: #666;
          i {
            font-size: 18px;
            color: #ccc;
            &.current {
              color: #fdb120;
            }
          }
        }
        .buyNum {
          margin-top: 15px;
          font-size: 16px;
          color: #999;
          span {
            color: $mainColor;
            font-size: 20px;
          }
        }
        .price {
          margin-top: 20px;
          padding: 0 10px;
          height: 45px;
          line-height: 45px;
          background: #ebfaff;
          span {
            &:nth-child(1) {
              color: #ff6600;
              font-size: 28px;
            }
            &:nth-child(2) {
              color: #999;
              font-size: 16px;
              margin-left: 30px;
              text-decoration: line-through;
            }
          }
        }
        .types {
          margin-top: 25px;
          font-size: 14px;
          span {
            color: #666;
            padding: 6px 15px;
            background-color: #f4f4f4;
          }
        }
        .but {
          margin-top: 30px;
          display: flex;
          // box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
          > div {
            background-color: #fff;
            padding: 10px;
            width: 170px;
            margin-left: 28px;
            &:nth-child(1) {
              margin-left: 0px;
            }

            p {
              font-size: 14px;
              margin-bottom: 5px;
              text-align: center;
            }
            img {
              width: 150px;
              height: 150px;
            }
          }
          &:hover > div {
            display: block;
          }
        }
      }
      .recommend {
        width: 200px;
        margin-left: 30px;
        border-left: 1px solid #eee;
        padding: 20px 0 30px 20px;
        flex-shrink: 0;
        .title {
          text-align: center;
        }
        .recommendList {
          margin-top: 10px;
          cursor: pointer;
          .recommendImg {
            width: 100%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            img {
              width: 100%;
            }
          }
          .content {
            margin-top: 8px;
            h2 {
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            > div {
              display: flex;
              margin-top: 5px;
              span {
                &:nth-child(1) {
                  color: red;
                }
                &:nth-child(2) {
                  color: #999;
                  font-size: 14px;
                  text-decoration: line-through;
                  margin-left: 15px;
                }
              }
            }
          }
        }
      }
    }
    .details {
      margin: 20px auto;
      max-width: 1200px;
      background-color: #fff;
      padding: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      > img {
        display: block;
        max-width: 100%;
      }
    }
    .detailsText {
      margin: 20px auto;
      max-width: 1200px;
      background-color: #fff;
      padding: 30px;
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1000px) {
  .templateDetailsPage {
    padding-top: 76px;
    .templateHeadBox {
      margin: 20px auto;
      max-width: 1200px;
      background-color: #fff;
      padding: 0 30px;
      display: flex;
      .imgPreviewBox {
        position: relative;
        display: flex;
        align-items: center;
        margin-right: 30px;
        flex-shrink: 0;
        padding: 30px 0;
        .preview {
          width: 260px;
          height: 482px;
          background: url(https://qn.kemean.cn/upload/201809/06/fe154e4732694900a7254981d1e3a893)
            no-repeat;
          background-size: 100%;
          position: relative;
          padding: 40px 30px 80px 30px;
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide {
              width: 100%;
              height: 100%;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .swiper-button-prev {
          position: initial;
        }
        .swiper-button-next {
          position: initial;
        }
      }
      .templateInfo {
        flex: 1;
        padding: 30px 0;
        h3 {
          color: #000;
          font-size: 22px;
          font-weight: bold;
        }
        .description {
          margin-top: 15px;
          color: #999;
          font-size: 16px;
        }
        .score {
          margin-top: 15px;
          color: #666;
          i {
            font-size: 18px;
            color: #ccc;
            &.current {
              color: #fdb120;
            }
          }
        }
        .buyNum {
          margin-top: 15px;
          font-size: 16px;
          color: #999;
          span {
            color: $mainColor;
            font-size: 20px;
          }
        }
        .price {
          margin-top: 20px;
          padding: 0 10px;
          height: 45px;
          line-height: 45px;
          background: #ebfaff;
          span {
            &:nth-child(1) {
              color: #ff6600;
              font-size: 28px;
            }
            &:nth-child(2) {
              color: #999;
              font-size: 16px;
              margin-left: 30px;
              text-decoration: line-through;
            }
          }
        }
        .types {
          margin-top: 25px;
          font-size: 14px;
          span {
            color: #666;
            padding: 6px 15px;
            background-color: #f4f4f4;
          }
        }
        .but {
          margin-top: 30px;
          display: flex;
          // box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
          > div {
            background-color: #fff;
            padding: 10px;
            width: 170px;
            margin-left: 28px;
            &:nth-child(1) {
              margin-left: 0px;
            }

            p {
              font-size: 14px;
              margin-bottom: 5px;
              text-align: center;
            }
            img {
              width: 150px;
              height: 150px;
            }
          }
          &:hover > div {
            display: block;
          }
        }
      }
      .recommend {
        width: 200px;
        margin-left: 30px;
        border-left: 1px solid #eee;
        padding: 20px 0 30px 20px;
        flex-shrink: 0;
        display: none;
        .title {
          text-align: center;
        }
        .recommendList {
          margin-top: 10px;
          cursor: pointer;
          margin-bottom: 15px;
          .recommendImg {
            width: 100%;
            height: 100px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .content {
            margin-top: 8px;
            h2 {
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            > div {
              display: flex;
              margin-top: 5px;
              span {
                &:nth-child(1) {
                  color: red;
                }
                &:nth-child(2) {
                  color: #999;
                  font-size: 14px;
                  text-decoration: line-through;
                  margin-left: 15px;
                }
              }
            }
          }
        }
      }
    }
    .details {
      margin: 20px auto;
      max-width: 1200px;
      background-color: #fff;
      padding: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      > img {
        display: block;
        width: 100%;
      }
    }
    .detailsText {
      margin: 20px auto;
      max-width: 1200px;
      background-color: #fff;
      padding: 30px;
    }
  }
}
@media screen and (max-width: 750px) {
  .templateDetailsPage {
    .templateHeadBox {
      background-color: #fff;
      .imgPreviewBox {
        position: relative;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        padding: 6vw 0;
        display: none;
        .preview {
          width: 100%;
          height: 185vw;
          background: url(https://qn.kemean.cn/upload/201809/06/fe154e4732694900a7254981d1e3a893)
            no-repeat;
          background-size: 100%;
          position: relative;
          padding: 15vw 12vw 32vw 11vw;
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide {
              width: 100%;
              height: 100%;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .swiper-button-prev {
          position: initial;
          display: none;
        }
        .swiper-button-next {
          position: initial;
          display: none;
        }
      }
      .templateInfo {
        flex: 1;
        padding: 6vw 3vw;
        h3 {
          color: #000;
          font-size: 5.5vw;
          font-weight: bold;
        }
        .description {
          margin-top: 3vw;
          color: #999;
          font-size: 3.5vw;
        }
        .score {
          margin-top: 3vw;
          color: #666;
          i {
            font-size: 3.6vw;
            color: #ccc;
            &.current {
              color: #fdb120;
            }
          }
        }
        .buyNum {
          margin-top: 3vw;
          font-size: 3.8vw;
          color: #999;
          span {
            color: $mainColor;
            font-size: 5vw;
          }
        }
        .price {
          margin-top: 4vw;
          padding: 0 2vw;
          height: 11vw;
          line-height: 11vw;
          background: #ebfaff;
          span {
            &:nth-child(1) {
              color: #ff6600;
              font-size: 5.5vw;
            }
            &:nth-child(2) {
              color: #999;
              font-size: 4vw;
              margin-left: 6vw;
              text-decoration: line-through;
            }
          }
        }
        .types {
          margin-top: 5vw;
          font-size: 3vw;
          span {
            color: #666;
            padding: 1.5vw 3vw;
            background-color: #f4f4f4;
          }
        }
        .but {
          margin-top: 4vw;
          display: flex;
          overflow-x: auto;
          > div {
            background-color: #fff;
            padding: 2vw;
            width: 34vw;
            margin-left: 6vw;
            &:nth-child(1) {
              margin-left: 0px;
            }

            p {
              font-size: 3vw;
              margin-bottom: 1vw;
              text-align: center;
            }
            img {
              width: 30vw;
              height: 30vw;
            }
          }
          &:hover > div {
            display: block;
          }
        }
      }
      .recommend {
        width: 200px;
        margin-left: 30px;
        border-left: 1px solid #eee;
        padding: 20px 0 30px 20px;
        flex-shrink: 0;
        display: none;
        .title {
          text-align: center;
        }
        .recommendList {
          margin-top: 10px;
          cursor: pointer;
          margin-bottom: 15px;
          .recommendImg {
            width: 100%;
            height: 100px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .content {
            margin-top: 8px;
            h2 {
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            > div {
              display: flex;
              margin-top: 5px;
              span {
                &:nth-child(1) {
                  color: red;
                }
                &:nth-child(2) {
                  color: #999;
                  font-size: 14px;
                  text-decoration: line-through;
                  margin-left: 15px;
                }
              }
            }
          }
        }
      }
    }
    .details {
      margin: 3vw auto;
      background-color: #fff;
      padding: 3vw 3vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      > img {
        display: block;
        width: 100%;
      }
    }
    .detailsText {
      margin: 3vw auto;
      background-color: #fff;
      padding: 3vw;
    }
  }
}
</style>
